/* eslint-disable react/require-default-props */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import StickyHeader from './StickyHeader';
import { HeaderContext } from '../../../../contexts/HeaderData/HeaderData';

function StickyHeaderVM({
  width, loginStatus, displayRewardsToolTip, topPosition,
}) {
  const { data } = useContext(HeaderContext);
  return (
    <StickyHeader
      navData={data}
      windowWidth={width}
      loginStatus={loginStatus}
      displayRewardsToolTip={displayRewardsToolTip}
      topPosition={topPosition}
    />
  );
}

StickyHeaderVM.propTypes = {
  width: PropTypes.number,
  displayRewardsToolTip: PropTypes.bool,
  loginStatus: PropTypes.string,
  topPosition: PropTypes.number,
};

export default StickyHeaderVM;
